import { CatalogSearch, RegistryCatalogQuery } from '../models/catalog.model';

type CatalogParams = Record<string, string | number>;

export function toSearchParams({ search, size }: CatalogSearch): CatalogParams {
  const term = search.trim();
  return term ? { search: term, size } : { size };
}

export function toCatalogParams(query: RegistryCatalogQuery): CatalogParams {
  const params = toSearchParams(query);
  return query.period ? { period: query.period, ...params } : params;
}
